// Estado de una promo con el badge común del ciclo de vida.
import { LifecycleStatusBadge } from '@/shared/patterns/Lifecycle';
import type { SalePromotionListItem } from '../api/promotionsContract';
import { listStatusOf } from '../lib/promotionsList';

export function ListStatusBadge({ promo, now }: { promo: SalePromotionListItem; now: Date }) {
    return <LifecycleStatusBadge status={listStatusOf(promo, now)} />;
}
